import React from 'react';

const ScoringRules = () => {
  const winPoints = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/win points.png'}
    alt={'Очки'}
    title={'Очки'}
  />;
  const coins = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/coins.png'}
    alt={'Монеты'}
    title={'Монеты'}
  />;
  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;
  const city = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/city.42008716.png'}
    alt={'Город'}
    title={'Город'}
  />;
  const centralQuarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/central quarter.7dd51bfd.png'}
    alt={'Центральный квартал'}
    title={'Центральный квартал'}
  />;
  const quarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/quarter.f69660fa.png'}
    alt={'Базовый квартал'}
    title={'Базовый квартал'}
  />;

  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title text-win-points-dark">
        Очки за действия
      </h2>

      <div className="rules-page_section">
        <p>
          Игрок получает очки {winPoints} за уничтожение отрядов {unit} противника — количество очков зависит от типа
          уничтоженного отряда.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Захват города</h2>
        <p>
          Условие захвата города {city} проверяется в конце раунда, после завершения фазы Войны всех игроков, но
          перед получением дохода.
        </p>
        <p>
          Для захвата вражеского города игроку необходимо иметь хотя бы 1 отряд {unit} на любом квартале
          {centralQuarter}{quarter} города. При этом никакой другой игрок не должен иметь отрядов на кварталах этого
          города.
        </p>
        <p>
          Захвативший город игрок получает очки {winPoints} в количестве, равном количеству захваченных строений и
          ключевых точек. А потерявший город игрок теряет очки {winPoints} в таком же количестве.
        </p>
        <p>
          Захвативший игрок также сразу начинает получать доход с ключевых точек и строений города, начиная с
          текущего раунда.
        </p>
        <p>
          <b>Без городов — без монет.</b> Если в конце раунда (уже после проверки захвата) у игрока не осталось ни
          одного города {city}, все его монеты {coins} сгорают. Пока у игрока нет городов, доход монет ему не
          начисляется — ни базовый, ни прибавки к нему (см. раздел «Доход»). Правило действует и в последнем раунде:
          монеты игрока без городов в итоговые очки {winPoints} не превращаются.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Досрочное завершение игры</h2>
        <p>
          Игра может завершиться досрочно, если в конце любого раунда (после получения дохода и сгорания монет у
          игроков без городов) лидер имеет
          преимущество в <b>70 или более очков</b> {winPoints} относительно каждого другого игрока.
        </p>
        <p>
          При этом учитываются не только очки, но и монеты игроков: 2 монеты {coins} приравниваются 1 очку
          {winPoints}.
        </p>
        <p>
          Игра также завершается в конце раунда, если у всех игроков, кроме одного, не осталось <b>ни отрядов, ни
          городов</b> {city}, а у оставшегося очков {winPoints} больше, чем у каждого из них (с учетом монет, как в
          итогах игры).
        </p>
      </div>
    </div>
  );
};

export default ScoringRules;
